<template>
  <div id="cms-page">
    <breadcrumbs
      :with-homepage="true"
      :routes="[]"
      :active-route="cmsPageContent.title"
    />
    <div class="container">
      <h1 class="page-title" v-if="cmsPageContent.content_heading">
        {{ cmsPageContent.content_heading }}
      </h1>
    </div>

    <div class="faq">
      <div
        class="container"
        :id="cmsPageContent.content.includes('pagebuilder') || true ? 'html-body' : ''"
        :class="cmsPageContent.content.includes('pagebuilder') || true ? 'pagebuilder-container' : ''"
        v-html="cmsHtml"
        ref="cmscontent"
      />
    </div>
    <script v-if="faqJsonLd" v-html="faqJsonLd" type="application/ld+json" />
  </div>
</template>

<script>
import Breadcrumbs from 'theme/components/core/Breadcrumbs'
import CmsPage from '@vue-storefront/core/pages/CmsPage'
import { faqPageJsonLd, unescapeEncodedTags } from 'theme/helpers/faqJsonLd'

export default {
  components: {
    Breadcrumbs
  },
  computed: {
    cmsPageContent () {
      return this.$store.state.cmsPage.current
    },
    cmsHtml () {
      const page = this.cmsPageContent
      if (!page || typeof page.content !== 'string') return ''
      return unescapeEncodedTags(page.content)
    },
    faqJsonLd () {
      const page = this.cmsPageContent
      if (!page || typeof page.content !== 'string') return ''
      const data = faqPageJsonLd(page.content)
      return data ? JSON.stringify(data) : ''
    }
  },
  mounted () {
    const panelHeadings = this.$refs.cmscontent.getElementsByClassName('panel-heading');
    for (let i = 0; i < panelHeadings.length; i++) {
      panelHeadings[i].addEventListener('click', function (event) {
        event.preventDefault();
        this.parentElement.classList.toggle('show');
      })
    }
  },
  mixins: [CmsPage]
}
</script>
